import { render, staticRenderFns } from "./OffersFilters.vue?vue&type=template&id=bec514a6&scoped=true"
import script from "./OffersFilters.vue?vue&type=script&lang=ts"
export * from "./OffersFilters.vue?vue&type=script&lang=ts"
import style0 from "./OffersFilters.vue?vue&type=style&index=0&id=bec514a6&prod&scoped=true&lang=css"
import style1 from "./OffersFilters.vue?vue&type=style&index=1&id=bec514a6&prod&global=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bec514a6",
  null
  
)

export default component.exports